import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { TriggerType } from "../../../types/types";
import Spinner from "../../../ui/Spinner/Spinner";

export const Triggers = () => {
  const { t } = useTranslation();

    // Получение данных и обновление их в сторе.
    const [loading, setLoading] = useState(true);
    const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/triggers/sensor_type`);
    const [triggers, setTriggers] = useState<TriggerType[]>();
  
    useEffect(() => {
      setLoading(true);
      doFetchItem();
    }, []);
  
    useEffect(() => {
      if (!response) {
        return;
      }
      setTriggers(response.data as unknown as TriggerType[]);
      setLoading(false);
    }, [response]);

  
  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-background px-6">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{t('global_triggers')}</span>
        </div>
      </div>
      {loading ? <Spinner /> : <Outlet context={[triggers, setTriggers]} />}
    </div>
  )
};
